// @ts-ignore
import $ from 'jquery';

export default function layoutFullScreenDisable() {


    gd.bus.triggerEvent("full-screen:off");

    // this.left && this.left.show();
    gd.layout.uiLeftNode.classList.remove('full-screen-hidden')

    if (!gd.top.isEmpty) {
        gd.layout.top.fullScreen(false);
        gd.layout.top.open();
    }

    const $uiLayout = $("#ui-div-zero"); // center make full
    $uiLayout.removeClass('full-screen');
}

//
// gd.bus.triggerEvent("full-screen:off");
//
// this.left && this.left.show();
//
// if (!gd.top.isEmpty) {
//     gd.layout.top.fullScreen(false);
//     this.top.open();
// }
//
// const $uiLayout = $("#ui-div-zero"); // center make full
// $uiLayout.removeClass('full-screen');